export const getApiData = (response) => {
  return response?.data?.data || response?.data?.Data || response?.data || {};
};

export const getApiMessage = (error, fallback = "Something went wrong.") => {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.Message ||
    error?.response?.data?.title ||
    error?.message ||
    fallback
  );
};

export const getPagedItems = (response) => {
  const data = getApiData(response);
  if (Array.isArray(data)) return data;

  const nestedData = data?.data || data?.Data;

  return (
    data?.items ||
    data?.Items ||
    data?.records ||
    data?.Records ||
    data?.results ||
    data?.Results ||
    nestedData?.items ||
    nestedData?.Items ||
    (Array.isArray(nestedData) ? nestedData : [])
  );
};

export const getApiTotalCount = (response) => {
  const data = getApiData(response);
  return data?.totalCount || data?.TotalCount || 0;
};
